import React, { useEffect, useState } from "react";
import {
  Button,
  Label,
  TextInput,
  Textarea,
  FileInput,
} from "flowbite-react";
import axios from "axios";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import "../style/Login.css";
import Sidebar from "../layout/Sidebar";
import AgentSidebar from "../layout/AgentSidebar";

const MyProfile = () => {
  const baseURL = process.env.REACT_APP_BASE_URL;

  const [admin, setAdmin] = useState({
    id: "",
    admin_id: "",
    name: "",
    password: "",
    aadhar_no: "",
    address: "",
    contact_no: "",
    image: null,
    imagePreview: null,
  });

  const role = sessionStorage.getItem("role");

  useEffect(() => {
    const fetchAdmin = async () => {
      try {
        const accessToken = sessionStorage.getItem("access_token");

        const response = await axios.get(`${baseURL}/getAllAdmin`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });

        if (response.data.length > 0) {
          const item = response.data[0];

          let imageURL = null;

          if (item.image) {
            try {
              const imageResponse = await axios.get(
                `${baseURL}/images/AgentImages/${item.image}`,
                {
                  headers: {
                    Authorization: `Bearer ${accessToken}`,
                  },
                  responseType: "blob",
                }
              );
              imageURL = URL.createObjectURL(imageResponse.data);
            } catch (imageError) {
              console.error("Error fetching image:", imageError);
            }
          }

          setAdmin({
            id: item.id, // ✅ important for update!
            admin_id: item.admin_id,
            name: item.name,
            password: item.password,
            aadhar_no: item.aadhar_no || "",
            address: item.address || "",
            contact_no: item.contact_no || "",
            image: null,
            imagePreview: imageURL,
          });
        }
      } catch (error) {
        console.error("Error fetching admin:", error);
      }
    };

    fetchAdmin();
  }, [baseURL]);

  const handleChange = (e) => {
    setAdmin({ ...admin, [e.target.name]: e.target.value });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setAdmin({
      ...admin,
      image: file,
      imagePreview: URL.createObjectURL(file),
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();

      // ✅ Correct field names for Flask API
      formData.append("agentid", admin.admin_id);
      formData.append("aadharNo", admin.aadhar_no);
      formData.append("address", admin.address);
      formData.append("contactno", admin.contact_no);
      formData.append("id", admin.id); // ✅ Must send DB id!

      if (admin.image) {
        formData.append("image", admin.image);
      }

      const accessToken = sessionStorage.getItem("access_token");

      const response = await axios.put(`${baseURL}/updateAdmin`, formData, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          text: "Profile updated successfully!",
          timer: 2000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      console.error("Profile update error:", error);
      Swal.fire({
        icon: "error",
        text: "Failed to update profile.",
      });
    }
  };

  const SidebarComponent = role === "admin" ? <Sidebar /> : <AgentSidebar />;

  return (
    <div className="flex min-h-screen bg-white">
      {SidebarComponent}
      <div className="flex-1 flex justify-center items-center py-10 px-4">
        <div className="w-full max-w-4xl bg-gradient-to-br from-blue-400 to-indigo-500 rounded-2xl p-1 shadow-lg">
          <div className="bg-white rounded-2xl p-8">
            <form className="flex flex-col gap-6" onSubmit={handleSubmit}>
              <h2 className="text-xl font-semibold text-center text-gray-800">
                My Profile
              </h2>

              {/* Profile Image Upload */}
              <div className="flex justify-center">
                <label
                  htmlFor="imageUpload"
                  className="cursor-pointer relative group"
                >
                  {admin.imagePreview ? (
                    <img
                      src={admin.imagePreview}
                      alt="Profile"
                      className="w-28 h-28 rounded-full object-cover border-2 border-gray-300 hover:opacity-80 transition"
                    />
                  ) : (
                    <div className="w-28 h-28 rounded-full bg-gray-200 flex items-center justify-center text-gray-600 border-2 border-gray-300">
                      Upload
                    </div>
                  )}
                  <span className="absolute bottom-0 right-0 bg-white text-xs text-black px-1 py-0.5 rounded shadow-sm opacity-0 group-hover:opacity-100 transition">
                    Change
                  </span>
                </label>
                <FileInput
                  id="imageUpload"
                  accept="image/*"
                  onChange={handleImageChange}
                  className="hidden"
                />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <Label value="Admin ID" />
                  <TextInput readOnly value={admin.admin_id} />
                </div>

                <div>
                  <Label value="Name" />
                  <TextInput readOnly value={admin.name} />
                </div>

                <div>
                  <Label value="Password" />
                  <TextInput type="text" readOnly value={admin.password} />
                </div>

                <div>
                  <Label value="Aadhar Number" />
                  <TextInput
                    name="aadhar_no"
                    value={admin.aadhar_no}
                    onChange={handleChange}
                  />
                </div>

                <div>
                  <Label value="Contact Number" />
                  <TextInput
                    name="contact_no"
                    value={admin.contact_no}
                    onChange={handleChange}
                  />
                </div>

                <div className="md:col-span-2">
                  <Label value="Address" />
                  <Textarea
                    name="address"
                    value={admin.address}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="flex justify-center">
                <Button type="submit" color="warning">
                  Update Profile
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyProfile;
